import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=cdc50368&scoped=true&"
var script = {}
import style0 from "./Calendar.vue?vue&type=style&index=0&id=cdc50368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc50368",
  null
  
)

export default component.exports